import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Premium Tea',
        content: 'Finest tea leaves handpicked from renowned gardens, offering rich aromas and soothing flavors in every cup.',
        paragraphs: [
            'Experience the elegance of premium teas curated from world-famous regions. Each batch is carefully selected and packed to preserve its freshness, aroma, and natural taste.',
            'From floral blends to bold traditional teas, we offer options suitable for relaxation, energy boost, or daily indulgence—ideal for both casual sippers and connoisseurs.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Single-Origin & Herbal Infusions',
            'Naturally Caffeine-Free Options',
            'Loose Leaf & Bagged Varieties',
            'Delicate Fragrance & Taste',
            'Great for Hot or Iced Brewing'
        ],
        process: [
            'Choose Preferred Tea Type',
            'Select Loose or Bagged Packaging',
            'Blending and Aroma Check',
            'Packaging with Freshness Seal',
            'Pickup or Home Delivery'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Where do your tea leaves come from?',
                content: 'We source our teas from top estates in India, China, Sri Lanka, and other premium regions known for quality.'
            },
            {
                id: 2,
                heading: 'Do you offer both loose leaf and tea bags?',
                content: 'Yes, you can choose from our loose leaf collection or convenient tea bags, depending on your preference.'
            },
            {
                id: 3,
                heading: 'How should I store my tea for freshness?',
                content: 'Keep your tea in an airtight container away from heat, moisture, and light to maintain its flavor and aroma.'
            },
            {
                id: 4,
                heading: 'Can I create a custom blend?',
                content: 'Definitely! We offer custom blending services for customers who want unique combinations of herbs and teas.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'In-house Brewing',
        content: 'Expertly brewed teas prepared fresh on-site using precise techniques to bring out the finest flavor in every cup.',
        paragraphs: [
            'Our in-house brewing ensures every cup of tea is prepared with consistency, care, and craftsmanship. Using optimal steeping times and temperatures, we highlight the unique notes of each blend.',
            'From traditional kettles to modern infusion methods, our brewing station offers a delightful experience—ensuring purity, balance, and a rich taste profile.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Precision Steeping Techniques',
            'Consistent Brewing Quality',
            'Hot & Cold Tea Options',
            'Infusion-Friendly Equipment',
            'Barista-Crafted Presentations'
        ],
        process: [
            'Select Tea from Menu',
            'Measure Tea Quantity',
            'Steep at Optimal Temperature',
            'Strain and Serve Fresh',
            'Garnish with Herbs (Optional)'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How is your tea brewed on-site?',
                content: 'We use precise brewing methods, including temperature control and steep time adjustments for each type of tea.'
            },
            {
                id: 2,
                heading: 'Can I watch the brewing process?',
                content: 'Yes, our open brewing bar allows customers to observe and even learn the art of tea brewing.'
            },
            {
                id: 3,
                heading: 'Do you offer iced and hot tea versions?',
                content: 'Absolutely! Every tea can be served hot or iced, depending on your preference.'
            },
            {
                id: 4,
                heading: 'Are herbal teas brewed differently?',
                content: 'Yes, herbal teas usually require longer steeping and higher temperatures, which we adjust accordingly.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Fresh Leaves',
        content: 'Our tea leaves are handpicked for peak freshness, delivering a natural and aromatic tea experience.',
        paragraphs: [
            'We take pride in offering fresh tea leaves that are free from additives and preservatives. Carefully harvested at the right time, our leaves retain their full flavor and health benefits.',
            'Whether it’s green, black, herbal, or oolong, our teas start with premium-quality leaves to ensure every brew is wholesome and satisfying.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Organically Sourced',
            'Handpicked at Peak Freshness',
            'Wide Variety of Tea Types',
            'No Artificial Additives',
            'Full-Bodied Flavor and Aroma'
        ],
        process: [
            'Partner with Organic Growers',
            'Handpick and Sort Leaves',
            'Dry Naturally in Controlled Environments',
            'Seal for Freshness and Aroma',
            'Deliver Direct from Garden to Cup'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Are your leaves certified organic?',
                content: 'Yes, we work with certified organic farms to ensure every leaf is grown naturally and responsibly.'
            },
            {
                id: 2,
                heading: 'How do you preserve freshness?',
                content: 'Leaves are dried in controlled environments and packaged with airtight seals to lock in freshness and aroma.'
            },
            {
                id: 3,
                heading: 'Can I buy loose-leaf tea?',
                content: 'Absolutely. We offer loose-leaf options in various quantities for customers who prefer brewing it themselves.'
            },
            {
                id: 4,
                heading: 'Do you offer seasonal leaves?',
                content: 'Yes, we feature seasonal harvests that showcase the unique flavor notes of different times of the year.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Flavor Variety',
        content: 'Explore an extensive range of tea flavors—from classic blends to modern infusions—crafted to suit every taste preference.',
        paragraphs: [
            'Our collection includes an exciting mix of traditional and contemporary tea flavors. Whether you crave bold spices, fruity notes, or floral undertones, we’ve got something to awaken your senses.',
            'With rotating seasonal specials and signature blends, our flavor selection is always evolving to keep your tea experience fresh and exciting.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Over 30+ Flavor Options',
            'Classic, Herbal, and Fusion Blends',
            'Rotating Seasonal Specials',
            'Customizable Flavor Combinations',
            'Available in Loose-Leaf or Tea Bags'
        ],
        process: [
            'Curate Flavors from Global Sources',
            'Blend for Taste Balance & Aroma',
            'Run Freshness & Quality Checks',
            'Package by Type (Loose/Bagged)',
            'Offer In-Store & Online Selection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How many tea flavors do you offer?',
                content: 'We offer over 30 unique flavors, including herbal, fruit-infused, spicy, and floral varieties.'
            },
            {
                id: 2,
                heading: 'Can I create my own blend?',
                content: 'Yes, we offer custom blend options where you can mix flavors to suit your preferences.'
            },
            {
                id: 3,
                heading: 'Are all flavors available year-round?',
                content: 'We have a core selection available year-round and rotate seasonal specials every few months.'
            },
            {
                id: 4,
                heading: 'Are these flavors naturally infused?',
                content: 'Yes, all our flavors are naturally derived from real fruits, herbs, and spices—no synthetic additives.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Loose Blend',
        content: 'Enjoy the authentic aroma and taste of our hand-blended loose-leaf teas, crafted for superior quality and steeping experience.',
        paragraphs: [
            'Our loose blend teas are made from whole, unbroken leaves that preserve their full flavor and aroma. Each blend is thoughtfully curated to deliver a rich and satisfying cup.',
            'Whether you prefer herbal, green, or black teas, our loose blends offer a customizable and elevated brewing experience that tea bags simply can’t match.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Whole Leaf Quality',
            'Hand-Blended for Consistency',
            'Available in Reusable Packaging',
            'Higher Antioxidant Retention',
            'Perfect for Traditional Brewing Methods'
        ],
        process: [
            'Source Premium Loose Leaves',
            'Blend Ingredients by Hand',
            'Conduct Freshness & Aroma Checks',
            'Package in Airtight Containers',
            'Provide Brewing Instructions'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What makes loose blend tea better?',
                content: 'Loose blends use whole leaves, which means more oils and natural compounds stay intact—enhancing flavor and health benefits.'
            },
            {
                id: 2,
                heading: 'How should I brew loose blend tea?',
                content: 'Use 1–2 teaspoons per cup, steep in hot water (80–100°C depending on type), and allow 3–5 minutes for full extraction.'
            },
            {
                id: 3,
                heading: 'Do you offer storage solutions?',
                content: 'Yes, we offer reusable and airtight containers to preserve freshness and aroma.'
            },
            {
                id: 4,
                heading: 'Can I sample blends before buying?',
                content: 'Absolutely! We offer small sampler packs so you can explore flavors before committing to a full purchase.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Perfect Steeping',
        content: 'Achieve optimal flavor and aroma every time with our steeping guidance, tailored to each tea type and preference.',
        paragraphs: [
            'Steeping tea correctly makes a world of difference. We provide expert advice and tools to help you brew each cup with precision and care.',
            'From water temperature to steeping time, we ensure every step is perfected—so you get the most out of your herbal, green, black, or specialty teas.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Custom Steeping Guides per Tea Type',
            'Recommended Water Temperatures',
            'Ideal Steeping Times Provided',
            'Tea-to-Water Ratios for Every Cup',
            'Tools & Accessories Available'
        ],
        process: [
            'Choose Your Tea Type',
            'Measure Proper Leaf Quantity',
            'Use Correct Water Temperature',
            'Steep for Suggested Time',
            'Enjoy a Perfectly Brewed Cup'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Does steeping time affect tea taste?',
                content: 'Yes, over-steeping can make tea bitter, while under-steeping may result in a weak flavor. That’s why timing is essential.'
            },
            {
                id: 2,
                heading: 'Do you provide steeping tools?',
                content: 'We offer thermometers, timers, and infusers to help you steep with confidence and consistency.'
            },
            {
                id: 3,
                heading: 'Are your guides suitable for beginners?',
                content: 'Absolutely! Our step-by-step steeping tips are beginner-friendly yet detailed enough for tea connoisseurs.'
            },
            {
                id: 4,
                heading: 'Can I use the same method for all teas?',
                content: 'Each tea type has unique steeping needs. We provide specific guidelines for each category to ensure the best experience.'
            }
        ]
    }

];

export default services;